import {
  timestampOrDateToDate,
  toGoogleCalendarDateString,
  toLocalICSDateTime,
} from "../utils/datetime";
import { DanceEvent, Location } from "../types";

interface CalendarLinksProps {
  event: DanceEvent;
  location?: Location;
}

export const CalendarLinks = (props: CalendarLinksProps) => {
  const title = props.event.name;
  const description = props.event.description || props.event.short_description;

  if (!(title && description && props.event.end && props.location)) {
    // required for calendars
    return;
  }
  const location = props.location?.name + ", \n" + props.location.address;

  const googleParams = new URLSearchParams("action=TEMPLATE");
  googleParams.set("text", title);
  googleParams.set("ctz", "Australia/Adelaide");
  googleParams.set("details", description);
  googleParams.set("location", location);
  googleParams.set(
    "dates",
    toGoogleCalendarDateString(props.event.start) +
      "/" +
      toGoogleCalendarDateString(props.event.end)
  );
  const googleUrl =
    "https://calendar.google.com/calendar/render?" + googleParams;

  const outlookParams = new URLSearchParams(
    "path=/calendar/action/compose&rru=addevent"
  );

  outlookParams.set("subject", title);
  outlookParams.set("body", description);
  outlookParams.set("location", location);
  outlookParams.set(
    "startdt",
    timestampOrDateToDate(props.event.start).toISOString()
  );
  outlookParams.set(
    "enddt",
    timestampOrDateToDate(props.event.end).toISOString()
  );

  const outlookUrl =
    "https://outlook.live.com/calendar/0/action/compose?" + outlookParams;

  const office365Url =
    "https://outlook.office.com/calendar/0/action/compose?" + outlookParams;

  const iCalEscape = (label: string, text: string) => {
    // fold before byte 75
    return (
      label + ":" + text.replace(/([",:;\\])/, "\\$1").replace(/\s*\n/g, "\\n")
    );
  };

  const iCalendar = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//ceroc-adelaide.com.au//calendar-link//EN
BEGIN:VEVENT
DTSTAMP${toLocalICSDateTime(new Date())}
ORGANIZER;CN=Ceroc & Modern Jive Adelaide:mailto:info@ceroc-adelaide.com.au
DTSTART${toLocalICSDateTime(props.event.start)}
DTEND${toLocalICSDateTime(props.event.end)}
SUMMARY:${title}
${iCalEscape("DESCRIPTION", description)}
${iCalEscape("LOCATION", location)}
UID:ceroc-adelaide.com.au/${props.event.id}
END:VEVENT
END:VCALENDAR
`;

  const icsUrl = "data:text/calendar;charset=utf8," + iCalendar;

  return (
    <div class="expand-menu">
      <label>
        <input type="checkbox" />
        <span class="label">🗓️ Add to Calendar</span>
        <div class="popout">
          <div>
            <a href={googleUrl} target="_blank">
              Add to Google Calendar
            </a>
          </div>
          <div class="pt">
            <a href={outlookUrl} target="_blank">
              Add to Outlook Calendar
            </a>
          </div>
          <div class="pt">
            <a href={office365Url} target="_blank">
              Add to Office 365 Calendar
            </a>
          </div>
          <div class="pt">
            <a href={icsUrl} download={title + ".ics"} target="_blank">
              Download iCalendar file
            </a>
            <div>For Apple Calendar, Thunderbird, and others</div>
          </div>
        </div>
      </label>
    </div>
  );
};
